export default __webpack_public_path__ + "static/media/mockExamStudent.11b1f2bc.jpg";